import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import { unwrapContentfulLocaleField } from 'src/common/parsers'

function normalizeFaqQuestionLabel(question) {
  if (question == null) return ''
  if (typeof question === 'string') return question.trim()
  if (typeof question === 'object' && question.nodeType === 'document') {
    try {
      return documentToPlainTextString(question).trim()
    } catch {
      return ''
    }
  }

  return ''
}

/**
 * Maps Contentful FAQ references (flat `parseEntry` rows and/or `{ fields }`) to
 * `{ title, content }` for `FAQ/Accordion`. Used by article, blog, and geo pages.
 */
export function parseContentfulFaqForAccordion(rawFaq = []) {
  const list = Array.isArray(rawFaq) ? rawFaq : []

  return list
    .map((item) => {
      const rawQuestion = unwrapContentfulLocaleField(
        item?.fields?.question ?? item?.question
      )
      const rawAnswer = unwrapContentfulLocaleField(
        item?.fields?.answer ?? item?.answer
      )

      return {
        title: normalizeFaqQuestionLabel(rawQuestion),
        content: rawAnswer,
      }
    })
    .filter((item) => item.title && item.content)
}
